import React, { useEffect } from 'react';

import Polling from 'handshq-app/utilities/polling';
import DownloadIcon from 'icons/ic-download.svg';
import { useTranslation } from 'react-i18next';

import OutlinedButton from 'components/application/buttons/OutlinedButton';

export default function PersonnelTrainingDownload({
  isDisabled,
  onDownloadClick,
  onTrainingEvidenceProcessed,
  personnelId,
  trainingEvidenceProcessed,
}) {
  const { t: i18nTCommon } = useTranslation('common');

  const evidenceStatusUrl = `/personnel/${personnelId}/training_evidence_status`;

  useEffect(() => {
    if (!trainingEvidenceProcessed) {
      evidenceStatusPoller.start();
    }
    return () => {
      if (evidenceStatusPoller) {
        evidenceStatusPoller.end();
      }
    };
  }, [trainingEvidenceProcessed]);

  const evidenceStatusPoller = new Polling({
    interval: 1000,
    url: evidenceStatusUrl,
    responseCheck(response) {
      return response.data.processed;
    },
    successCallback: () => {
      onTrainingEvidenceProcessed();
    },
    failureCallback: () => {
      console.error('could not load attachments status');
    },
  });

  return (
    <OutlinedButton
      color='grey'
      disabled={isDisabled}
      onClick={() => onDownloadClick()}
      size='sm'
    >
      <DownloadIcon className='-tw-ml-2' height={24} width={24} />
      <span>{i18nTCommon('training.downloadTrainingReport')}</span>
    </OutlinedButton>
  );
}
